import { FoodsIcon, IconMapping, LinearProgress } from "@foodpilot/foods";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { t } from "i18next";

type EntitiesHeaderProps = {
    icon: keyof IconMapping;
    title: string;
    count: number;
    completion?: number;
};
export const EntitiesHeader = (props: EntitiesHeaderProps) => {
    const { icon, title, count, completion } = props;
    const theme = useTheme();

    return (
        <Stack direction={"row"} gap={theme.spacing(2.5)} width={"100%"} alignItems="center">
            <Stack
                alignItems={"center"}
                justifyContent={"center"}
                sx={{
                    backgroundColor: (theme) => theme.custom.grey[400],
                    borderRadius: "28px",
                    padding: theme.spacing(1),
                }}
                width={"44px"}
                height={"44px"}
            >
                <FoodsIcon icon={icon} size={3.5} />
            </Stack>
            <Stack>
                <Stack direction={"row"} alignItems={"baseline"} gap={theme.spacing(0.75)}>
                    <Typography variant="h3">{title}</Typography>
                    <Typography variant="huge">{`- ${count}`}</Typography>
                </Stack>
                {completion !== undefined && (
                    <Stack>
                        <Box display="flex" alignItems="center" gap={theme.spacing(1.5)}>
                            <Typography variant="body-medium">{t("completion_totale")} :</Typography>
                            <Box width="200px">
                                <LinearProgress value={completion} />
                            </Box>
                        </Box>
                    </Stack>
                )}
            </Stack>
        </Stack>
    );
};
